import type { NavLink } from '../types';

export const navLinks: readonly NavLink[] = [
  { label: 'Profile', href: '#profile' },
  { label: 'Work', href: '#work' },
  { label: 'Stack', href: '#stack' },
  { label: 'Contact', href: '#contact' },
];
